import React, { memo } from "react";
import { Col, Row, Form, InputGroup } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

const DateSelect = ({ title, dates, setDates, clarifyingText, children }) => {
    return (
        <Row>
            <Form.Group as={Row}>
                <Form.Label className='vertical-align-middle' column xs={1}>{title}</Form.Label>
                <Col xs={5}>
                    <InputGroup>
                        <Col xs={5}>
                            <DatePicker
                                name={`datepicker-${new Date()}`}
                                calendarStartDay={1}
                                className="form-control text-center"
                                placeholderText="Select From"
                                onChange={date => setDates({ ...dates, start: new Date(date).toISOString() })}
                                dateFormat={'dd/MM/yyyy'}
                                selected={dates?.start ? new Date(dates?.start) : ''}
                                isClearable />
                        </Col>
                        <Col xs={1}>
                            <InputGroup.Text>To</InputGroup.Text>
                        </Col>
                        <Col xs={5}>
                            <DatePicker
                                name={`datepicker-${new Date()}`}
                                calendarStartDay={1}
                                className="form-control text-center"
                                placeholderText="Select To"
                                onChange={date => setDates({ ...dates, end: new Date(date).toISOString() })}
                                dateFormat={'dd/MM/yyyy'}
                                selected={dates?.end ? new Date(dates?.end) : ''}
                                isClearable />
                        </Col>
                    </InputGroup>
                    {
                        clarifyingText &&
                        <p className='text-500'><small>{clarifyingText}</small></p>
                    }
                </Col>
                <Col>
                    {children}
                </Col>
            </Form.Group>
        </Row>
    );
}

DateSelect.propTypes = {
    title: PropTypes.string,
    dates: PropTypes.object,
    setDates: PropTypes.func,
    clarifyingText: PropTypes.string,
    children: PropTypes.node
};

export default memo(DateSelect);